import React from 'react';
import { Link } from 'react-router-dom';
import { NewTabHint } from './NewTabHint';
type Variant = 'primary' | 'secondary' | 'onDark' | 'ghost';
const styles: Record<Variant, string> = {
  primary: 'bg-brand-navy text-white border-2 border-brand-navy hover:bg-[#083a7c] hover:border-[#083a7c]',
  secondary: 'bg-white text-brand-navy border-2 border-brand-navy hover:bg-brand-tan',
  onDark: 'bg-brand-yellow text-[#3d2b00] border-2 border-brand-yellow hover:bg-[#f7d454] hover:border-[#f7d454]',
  ghost: 'bg-transparent text-brand-navy border-2 border-transparent underline underline-offset-4 hover:border-brand-navy hover:no-underline'
};
const shared = 'inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full px-6 py-3 text-center font-display text-[15px] font-semibold leading-snug transition-colors duration-150 sm:text-base';
type CommonProps = {
  variant?: Variant;
  className?: string;
  children: React.ReactNode;
};
export function ButtonLink({
  to,
  variant = 'primary',
  className = '',
  children
}: CommonProps & {
  to: string;
}) {
  return <Link to={to} className={`${shared} ${styles[variant]} ${className}`} data-id="element-365" data-mp="eq63dfsu15qt">
      {children}
    </Link>;
}
export function ButtonExternal({
  href,
  variant = 'primary',
  className = '',
  children
}: CommonProps & {
  href: string;
}) {
  const isMailto = href.startsWith('mailto:');
  return <a href={href} {...isMailto ? {} : {
    target: '_blank',
    rel: 'noopener noreferrer'
  }} className={`${shared} ${styles[variant]} ${className}`} data-id="element-366" data-mp="12n3ep6ik39dh">
      {children}
      {isMailto ? null : <NewTabHint data-id="element-367" data-mp="1cdy4gkv0gr3o" />}
    </a>;
}
export function ButtonAnchor({
  href,
  variant = 'primary',
  className = '',
  children
}: CommonProps & {
  href: string;
}) {
  return <a href={href} className={`${shared} ${styles[variant]} ${className}`} data-id="element-368" data-mp="1le2yltb71szw">
      {children}
    </a>;
}